import { useFbqAddToCart } from './useFbqAddToCart'

export function useFbqPaymentPopupAddToCart() {
  const { reportAddToCart } = useFbqAddToCart()
  const reported = new Set<string>()

  function reportAll(
    purchaseProductLists: any[],
    subscribeProductLists: any[],
  ) {
    for (const method of purchaseProductLists) {
      for (const p of method?.products ?? []) {
        if (!p?.productId || reported.has(p.productId))
          continue
        reported.add(p.productId)
        reportAddToCart(p.productId, 'Coins Package', p.price ?? 0)
      }
    }

    for (const method of subscribeProductLists) {
      for (const p of method?.products ?? []) {
        if (!p?.productId || !p.purchasePopShow || reported.has(p.productId))
          continue
        reported.add(p.productId)
        reportAddToCart(p.productId, 'Membership', p.preferentialPrice ?? p.price ?? 0)
      }
    }
  }

  return { reportAll }
}
